<script setup lang="ts">
import Skeleton from 'primevue/skeleton';
import { RouterLink } from 'vue-router';
import type { StatPill } from '@/types/StatGroup.types';

withDefaults(defineProps<{
    pills: StatPill[]
    loading?: boolean
}>(), {
    loading: false,
});
</script>

<template>
    <div v-if="pills.length" class="dashboard-stat-pills">
        <component
            :is="pill.to ? RouterLink : 'div'"
            v-for="pill in pills"
            :key="pill.label"
            class="dashboard-stat-pills__pill"
            :class="{ 'dashboard-stat-pills__pill--clickable': !!pill.to }"
            :to="pill.to ?? undefined"
        >
            <span class="dashboard-stat-pills__label">{{ pill.label }}</span>
            <Skeleton v-if="loading" width="32px" height="17px" border-radius="4px" />
            <span v-else class="dashboard-stat-pills__value">{{ pill.value }}</span>
        </component>
    </div>
</template>

<style lang="scss" scoped>
.dashboard-stat-pills {
    display: flex;
    width: 100%;
    flex-wrap: nowrap;
   //PHASE2: gap: 12px;
    gap: 20px;

    &__pill {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 24px;
        flex: 1 1 0;
        min-width: 0;
        height: 57px;
        padding: 0 20px 0 28px;
        background: $white-color;
        border: 1px solid $border-gray-color;
        border-radius: 20px;
        text-decoration: none;
        color: inherit;

        &--clickable {
            cursor: pointer;
        }
    }

    &__label {
        font-family: $font-family-archivo;
        font-size: 16px;
        font-weight: 400;
        line-height: 17px;
        color: rgba($black-color, 0.75);
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__value {
        font-family: $font-family-archivo;
        font-size: 16px;
        font-weight: 600;
        line-height: 17px;
        color: $black-color;
        flex-shrink: 0;
        white-space: nowrap;
    }
}
</style>
